import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_z37ahwyys6: FaireCollectionEntity = {
  token: "pbc_z37ahwyys6",
  type: "collection",
  name: "SNEAKERS",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8fac9cac3db5c246f179ca6ab9ea88a3efd7d09c661901c83a61af70978dda27.jpeg",
  itemCount: 8,
  description:
    "Chic Sneaker Collection!\nAce the style game with our sneakers! From tennis shoes to platform sneakers, this collection blends sporty flair with casual cool.\nFor styling tips or an exclusive look at new styles, check out our socials IG: @_lemonadeshoes or TIKTOK: @lemonadeshoes",
  brandToken: "b_mz3xxxsvnf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:30.734Z",
    importedBy: "entity-db-import-collections",
  },
};
